import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import Product from './MyProduct';
import Loading from './Loading';

class ProductsList extends Component {
  render() {
    const products = this.props.products;

    return (
      <div>
        {
          this.props.isFetching
            ? <Loading/>
            : (
              products.total ?

                <div>

                  <div className="products__list" itemscope itemtype="http://schema.org/ItemList">
                    <link itemprop="itemListOrder" content="Unordered"/>
                    {products.items.map(product =>
                      <Product key={product.id}
                              product={product}
                              onAddToMyProducts={this.props.onAddToMyProducts}
                              onRemoveFromMyProducts={this.props.onRemoveFromMyProducts}
                              qty={this.props.quantities && this.props.quantities[product.id] && this.props.quantities[product.id].qty.toString() || ''}
                              onQtyChange={this.props.onQtyChange}
                              onAddToCart={this.props.onAddToCart}/>
                    )}
                  </div>

                  <button className="button primary small products__button-add-all -bottom"
                          disabled={!Object.keys(this.props.quantities).length}
                          onClick={this.props.onAddToCart}>Add all Selected to Cart</button>

                  {
                    this.props.totalPages > 1 &&
                    <ReactPaginate previousLabel={'previous'}
                                  nextLabel={'next'}
                                  breakLabel=" "
                                  breakClassName={'ellipsis'}
                                  pageCount={Math.ceil(this.props.totalPages)}
                                  marginPagesDisplayed={2}
                                  pageRangeDisplayed={5}
                                  onPageChange={e => this.props.onPageChange(e.selected)}
                                  containerClassName={'pagination'}
                                  activeClassName={'current'}
                                  previousClassName="pagination-previous"
                                  nextClassName="pagination-next"
                                  disabledClassName="disabled"
                                  forcePage={this.props.page}/>
                  }
                </div>

                :

                <div className="callout alert">
                  We weren't able to find any products. <a onClick={this.props.onReset}>Clear refinements and search again?</a>
                </div>
            )
        }
      </div>
    );
  }
}

ProductsList.propTypes = {
  products: PropTypes.object.isRequired,
  quantities: PropTypes.object,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onAddToMyProducts: PropTypes.func,
  onRemoveFromMyProducts: PropTypes.func,
  onReset: PropTypes.func,
  onAddToCart: PropTypes.func,
  onQtyChange: PropTypes.func,
  isFetching: PropTypes.bool,
};

export default ProductsList;
